import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  .css-lbwokm[data-checked] {
    background-color: #28bab5;
  }

  label:last-child {
    margin-left: 1rem;
    margin-bottom: 0;
  }
`;
